import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { environment } from '../environments/environment';
import { Observable } from 'rxjs';

export function fspApiHeadersInterceptor(
  httpRequest: HttpRequest<unknown>,
  next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> {
  return next(
    httpRequest.clone({
      setHeaders: {
        'x-fsp-environment': environment.apiEnvironment,
        'x-subscription-key': environment.subscriptionKey,
      },
    }),
  );
}
